import * as React from "react";
import { Button, Tooltip } from "antd";
import { PropsCell } from "src/components/Sheet2/PropsCell2";
import { EntityFiltersPageStore } from "src/pages/EntityFiltersPage/EntityFiltersPageStore";
import { ZUid } from "src/types/zUid";
import { ZEntityRow } from "src/pages/EntityFiltersPage/EntityList/types";
import { multiStepOnRowClick } from "src/components/MultiStepTask/utils";
import { PlusCircleFilled } from "@ant-design/icons";
import { onError } from "src/common/onError";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";
import styles from "./CellBom3MaterialSelect.module.less";
import { Bom3MaterialModal } from "./Bom3MaterialModal";
import { Cell2WithModal } from "../Cell2WithModal";
import { ZBom3PosCellValue, ZBom3PosRow } from "../../ZBom3Position";
import { Bom3PositionStore } from "../../Bom3PositionsStore";
import { makeBom3MaterialFilterRestriction } from "./makeBom3MaterialFilterRestriction";

type PropsCellBom3MaterialSelect = {
  cell: PropsCell;
  cellValue: ZBom3PosCellValue | undefined;
  objMaterial: ZUid | null | undefined;
  positionStore: Bom3PositionStore;
  disabled: boolean;
  row: ZBom3PosRow;
  title: string;
  onFocus: (e: FocusEvent) => void;
};

export const CellBom3MaterialSelect: React.FC<PropsCellBom3MaterialSelect> = (
  props,
) => {
  const {
    cell,
    cellValue,
    objMaterial,
    positionStore,
    disabled,
    row,
    title,
    onFocus,
  } = props;
  const btnRef = React.useRef<HTMLElement>(null);
  const [matStore, setMatStore] = React.useState<EntityFiltersPageStore | null>(
    null,
  );

  const handleOpen = () => {
    if (objMaterial) {
      const onRowClick = (clickedRow: ZEntityRow) => {
        multiStepOnRowClick(clickedRow, entityStore);
      };
      const { settings } = positionStore;
      const sectionId = positionStore.findSectionId(row.rowId);
      const filterRestrictions = makeBom3MaterialFilterRestriction(
        settings.directoryMatrix,
        sectionId,
        settings.attMaterialType,
      );
      const entityStore = new EntityFiltersPageStore({
        objectId: objMaterial,
        selectionSettings: { selectionType: "radio" },
        onRowClick,
        filterRestrictions,
        actions: new Set(), // Чтобы не было кнопки создания модели, т.к. она вызывает переход на другую страницу.
        title,
      });
      setMatStore(entityStore);
    }
  };

  return (
    <Cell2WithModal
      cell={cell}
      btnRef={btnRef}
      isKeySpecial={(e) => e.code === "Enter"}
      onFocus={onFocus}
    >
      <Tooltip title={cellValue?.label}>
        <Button
          ref={btnRef}
          onClick={handleOpen}
          className={styles.button}
          disabled={disabled}
        >
          <div className={styles.buttonContent}>
            {cellValue ? (
              <a
                className={styles.materialLabel}
                href={makeUrl(PageUrl.entityCard, { id: cellValue.value })}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                {cellValue.label}
              </a>
            ) : (
              <div className={styles.materialLabel} />
            )}
            <div className={styles.rightIcon}>
              <PlusCircleFilled />
            </div>
          </div>
        </Button>
      </Tooltip>

      <Bom3MaterialModal
        store={matStore}
        close={() => setMatStore(null)}
        success={(currentRow) => {
          positionStore
            .directChangeValue(cell.cellKey, String(currentRow.id))
            .catch(onError);
        }}
      />
    </Cell2WithModal>
  );
};
